module.exports = __webpack_public_path__ + "img/2.608e52b5.jpg";